import React from 'react'
import { Card } from 'reactstrap'

function ExportFacebookScript({item, onSelect}) {
  
  return (
    <Card className='p-3 d-flex flex-column align-items-center h-100'>
      <svg className='mb-3' xmlns="http://www.w3.org/2000/svg" width="38.114" height="36.3" viewBox="0 0 38.114 36.3">
        <defs>
          <clipPath id="clip-path">
            <rect id="Rectangle_125" data-name="Rectangle 125" width="38.114" height="36.3" transform="translate(0 0)" fill="none" />
          </clipPath>
        </defs>
        <g id="Group_357" data-name="Group 357" transform="translate(0 0)">
          <g id="Group_356" data-name="Group 356" clip-path="url(#clip-path)">
            <path id="Path_104" data-name="Path 104" d="M0,32.7V28.1H14.85a20.476,20.476,0,0,0,.2,2.325A8.779,8.779,0,0,0,15.8,32.7Zm0-9.4V18.75H19.35a9.443,9.443,0,0,0-1.975,2.1A12.553,12.553,0,0,0,16.05,23.3ZM0,9.4H32V14H0ZM0,0H32V4.6H0Z" fill="#94f956" />
            <path id="Path_105" data-name="Path 105" d="M21,36.3a1.963,1.963,0,0,1-1.95-1.95,1.962,1.962,0,0,1,.575-1.4A1.838,1.838,0,0,1,21,32.35h5.7L22.1,29.1a1.822,1.822,0,0,1-.85-1.225,2.107,2.107,0,0,1,.3-1.525,1.712,1.712,0,0,1,1.2-.8,2.3,2.3,0,0,1,1.55.25l4.65,3.25-2-5.3a2.49,2.49,0,0,1,.125-1.6,1.741,1.741,0,0,1,1.175-1,1.987,1.987,0,0,1,1.6.075,1.709,1.709,0,0,1,1,1.125L32.7,27.7l1.55-5.45a1.882,1.882,0,0,1,.85-1.2,1.918,1.918,0,0,1,1.5-.2,2.192,2.192,0,0,1,1.225.9,1.763,1.763,0,0,1,.225,1.45l-3.1,11.6a2.5,2.5,0,0,1-.725,1.1A1.836,1.836,0,0,1,33,36.3Z" fill="#030541" />
          </g>
        </g>
      </svg>

      <h4 className='m-0 mb-3 text-body text-center text-truncate'>Export Scripts</h4>
      <button className='w-100 btn btn-info mb-0 mt-auto' onClick={onSelect}>Choose</button>
    </Card>
  )
}

export default ExportFacebookScript;